import React from 'react';
import { Button, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import { APP_ROUTES } from '@/src/constants';
import { useTranslation } from '@/src/i18n';
import List from '@/components/organisms/SearchResults/List';

const TlcOnlinePractitionersSection = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { items, total } = useSelector((state: any) => state?.tlcCards);

  const itemsSorted = React.useMemo(
    () =>
      [...items]
        .sort((a, b) => a.waitingRoomPatientNumber - b.waitingRoomPatientNumber)
        .slice(0, 3),
    [items],
  );

  return (
    <Stack sx={{ alignItems: 'center', '.search-card': { maxWidth: '100%' } }}>
      <Typography
        variant={isMobile ? 'h3' : 'h2'}
        color="primary"
        component="h2"
        textAlign="center"
        marginBottom={isMobile ? 3 : 4}
      >
        {t('teleconsultation-without-an-appointment-header')}
      </Typography>
      {itemsSorted.length > 0 && (
        <div className="flex w-full flex-col gap-3">
          <List items={itemsSorted} mode="tlc" />
        </div>
      )}
      {itemsSorted.length === 0 && (
        <Typography
          sx={{ fontStyle: 'italic', textAlign: 'center' }}
          color="info.light"
        >
          {t('no_available_direct _tlc_practitioner')}
        </Typography>
      )}
      <Link href={APP_ROUTES.TLC.NO_RDV_SEARCH} passHref legacyBehavior>
        <Button
          color="primary"
          variant="outlined"
          sx={{ my: 4, textAlign: 'center' }}
          data-testid="teleconsult-a-practitioner-without-an-appointment"
        >
          {items.length > 3
            ? t('other-doctors-available-btn', { count: total - 3 })
            : t('Teleconsult-a-practitioner-without-an-appointment')}
        </Button>
      </Link>
    </Stack>
  );
};

export default TlcOnlinePractitionersSection;
